import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../assets/img/YOCILAB-01.svg'; // Adjust the path as necessary

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAboutDropdownOpen, setIsAboutDropdownOpen] = useState(false);
  const [isProgramsDropdownOpen, setIsProgramsDropdownOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setIsAboutDropdownOpen(false); // Close dropdown when opening mobile menu
    setIsProgramsDropdownOpen(false); // Close programs dropdown too
  };

  const toggleAboutDropdown = () => {
    setIsAboutDropdownOpen(!isAboutDropdownOpen);
  };

  const toggleProgramsDropdown = () => {
    setIsProgramsDropdownOpen(!isProgramsDropdownOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsAboutDropdownOpen(false);
    setIsProgramsDropdownOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={closeMobileMenu}>
            <img 
              src={require('../assets/img/YOCILAB-01.png')} 
              alt="YOCILAB Logo" 
              className="logo-image" 
            />
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <ul className="nav-list">
            <li><Link to="/">Home</Link></li>
            <li className="dropdown">
              <Link to="/about/who-are-we" className="dropdown-toggle">About us</Link>
              <div className="dropdown-menu">
                <Link to="/about/who-are-we" className="dropdown-item">
                  <div className="dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 21h18"/>
                      <path d="M5 21V7l8-4v18"/>
                      <path d="M19 21V11l-6-4"/>
                    </svg>
                  </div>
                  <div className="dropdown-content">
                    <span className="dropdown-title">Who Are We</span>
                    <span className="dropdown-desc">Our story and mission</span>
                  </div>
                </Link>
                <Link to="/about/why-it-matters" className="dropdown-item">
                  <div className="dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <path d="M12 17h.01"/>
                    </svg>
                  </div>
                  <div className="dropdown-content">
                    <span className="dropdown-title">Why It Matters</span>
                    <span className="dropdown-desc">The importance of our work</span>
                  </div>
                </Link>
                <Link to="/about/our-team" className="dropdown-item">
                  <div className="dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  <div className="dropdown-content">
                    <span className="dropdown-title">Our Team</span>
                    <span className="dropdown-desc">Meet the people behind YOCILAB</span>
                  </div>
                </Link>
              </div>
            </li>
            <li className="dropdown">
              <Link to="/programs/yocilab-academy" className="dropdown-toggle">Programs</Link>
              <div className="dropdown-menu">
                <Link to="/programs/yocilab-academy" className="dropdown-item">
                  <div className="dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                      <path d="M6 12v5c3 3 9 3 12 0v-5"/>
                    </svg>
                  </div>
                  <div className="dropdown-content">
                    <span className="dropdown-title">YOCILAB Academy</span>
                    <span className="dropdown-desc">EdTech learning platform for skills development</span>
                  </div>
                </Link>
                <Link to="/programs/yocilab-hub" className="dropdown-item">
                  <div className="dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <div className="dropdown-content">
                    <span className="dropdown-title">YOCILAB Hub</span>
                    <span className="dropdown-desc">Innovation and collaboration spaces</span>
                  </div>
                </Link>
              </div>
            </li>
            <li><Link to="/signature-events">Signature Events</Link></li>
            <li><Link to="/seed4impact">Seed4Impact</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Mobile Navigation */}
        <nav className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <ul className="mobile-nav-list">
            <li><Link to="/" onClick={closeMobileMenu}>Home</Link></li>
            <li className="mobile-dropdown">
              <button 
                className="mobile-dropdown-toggle" 
                onClick={toggleAboutDropdown}
                aria-expanded={isAboutDropdownOpen}
              >
                About us
                <span className={`dropdown-arrow ${isAboutDropdownOpen ? 'open' : ''}`}>▼</span>
              </button>
              <div className={`mobile-dropdown-menu ${isAboutDropdownOpen ? 'open' : ''}`}>
                <Link to="/about/who-are-we" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  <div className="mobile-dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M3 21h18"/>
                      <path d="M5 21V7l8-4v18"/>
                      <path d="M19 21V11l-6-4"/>
                    </svg>
                  </div>
                  <div className="mobile-dropdown-content">
                    <span className="mobile-dropdown-title">Who Are We</span>
                    <span className="mobile-dropdown-desc">Our story and mission</span>
                  </div>
                </Link>
                <Link to="/about/why-it-matters" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  <div className="mobile-dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <path d="M12 17h.01"/>
                    </svg>
                  </div>
                  <div className="mobile-dropdown-content">
                    <span className="mobile-dropdown-title">Why It Matters</span>
                    <span className="mobile-dropdown-desc">The importance of our work</span>
                  </div>
                </Link>
                <Link to="/about/our-team" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  <div className="mobile-dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                      <circle cx="9" cy="7" r="4"/>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                    </svg>
                  </div>
                  <div className="mobile-dropdown-content">
                    <span className="mobile-dropdown-title">Our Team</span>
                    <span className="mobile-dropdown-desc">Meet the people behind YOCILAB</span>
                  </div>
                </Link>
              </div>
            </li>
            <li className="mobile-dropdown">
              <button 
                className="mobile-dropdown-toggle" 
                onClick={toggleProgramsDropdown}
                aria-expanded={isProgramsDropdownOpen}
              >
                Programs
                <span className={`dropdown-arrow ${isProgramsDropdownOpen ? 'open' : ''}`}>▼</span>
              </button>
              <div className={`mobile-dropdown-menu ${isProgramsDropdownOpen ? 'open' : ''}`}>
                <Link to="/programs/yocilab-academy" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  <div className="mobile-dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
                      <path d="M6 12v5c3 3 9 3 12 0v-5"/>
                    </svg>
                  </div>
                  <div className="mobile-dropdown-content">
                    <span className="mobile-dropdown-title">YOCILAB Academy</span>
                    <span className="mobile-dropdown-desc">EdTech learning platform for skills development</span>
                  </div>
                </Link>
                <Link to="/programs/yocilab-hub" className="mobile-dropdown-item" onClick={closeMobileMenu}>
                  <div className="mobile-dropdown-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <div className="mobile-dropdown-content">
                    <span className="mobile-dropdown-title">YOCILAB Hub</span>
                    <span className="mobile-dropdown-desc">Innovation and collaboration spaces</span>
                  </div>
                </Link>
              </div>
            </li>
            <li><Link to="/signature-events" onClick={closeMobileMenu}>Signature Events</Link></li>
            <li><Link to="/seed4impact" onClick={closeMobileMenu}>Seed4Impact</Link></li>
            <li><Link to="/contact" onClick={closeMobileMenu}>Contact</Link></li>
            <li className="mobile-donate-container">
              <button className="mobile-donate-btn" onClick={closeMobileMenu}>Donate</button>
            </li>
          </ul>
        </nav>

        <button className="donate-btn desktop-donate-btn">Donate</button>
      </div>
    </header>
  );
};

export default Header;
